var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavigationCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.8984 19.0646C30.8178 21.9839 30.8178 26.7172 27.8984 29.6367C24.979 32.5561 20.2458 32.5561 17.3263 29.6367C14.4069 26.7172 14.4069 21.9839 17.3263 19.0646C20.2458 16.1451 24.979 16.1451 27.8984 19.0646Z",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.375 16.875V33.75C39.375 35.8219 37.6969 37.5 35.625 37.5H9.375C7.30312 37.5 5.625 35.8219 5.625 33.75V16.875C5.625 14.8031 7.30312 13.125 9.375 13.125H13.125L15.8662 8.43C16.2019 7.85437 16.8188 7.5 17.4863 7.5H27.4313C28.0894 7.5 28.6988 7.845 29.0381 8.4075L31.875 13.125H35.625C37.6969 13.125 39.375 14.8031 39.375 16.875Z",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationCamera);
export default __webpack_public_path__ + "static/media/navigation-camera.846c4ca5.svg";
export { ForwardRef as ReactComponent };